import { Button, DynamicContainer, FormSection, Icon, IconButton } from '@hai/ui-react';
import { Formik } from 'formik';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FormikCheckbox } from 'src/js/component/base/form/formik-checkbox';
import { FormikTextfield } from 'src/js/component/base/form/formik-textfield';
import { StateButton } from 'src/js/component/base/state-button';
import { validateFormContext } from 'src/js/validator/validator';

import { OnvifViewModel, onvifValidationSchema } from './onvif-view-model';

export interface OnvifFormValues extends OnvifViewModel {}

interface Props {
  viewModel: OnvifViewModel;
  onSubmit?: (viewModel: OnvifViewModel) => void;
}

export const OnvifForm = (props: Props) => {
  const { t } = useTranslation();
  const formRef = useRef(null);

  const handleAddLocation = () => {
    const newLocations = [...formRef.current.values.location];
    newLocations.push('');
    formRef.current.setValues({
      ...formRef.current.values,
      location: newLocations,
    });
  };

  const handleRemoveLocation = (e: any, index: number) => {
    e.preventDefault();

    const newLocations = [...formRef.current.values.location];
    newLocations.splice(index, 1);
    formRef.current.setValues({
      ...formRef.current.values,
      location: newLocations,
    });
  };

  return (
    <Formik
      initialValues={{
        discovery: props.viewModel?.discovery ?? false,
        location: props.viewModel?.location ?? [],
      }}
      validationSchema={() => onvifValidationSchema(t)}
      onSubmit={props.onSubmit}
      enableReinitialize={true}
      innerRef={formRef}
    >
      {(formikProps) => {
        return (
          <form className="hai-mb-6">
            <FormSection title={t('settings.services.section.onvif.title')}>
              <DynamicContainer minColumns={2}>
                <FormikCheckbox name="discovery" label={t('settings.services.section.onvif.discovery')} />
                <div className="d-flex">
                  <div className="ml-auto">
                    <StateButton
                      variant="primary"
                      onClick={() => validateFormContext(formikProps, t)}
                      disabled={!formikProps.dirty}
                    >
                      {t('general.apply')}
                    </StateButton>
                  </div>
                </div>
              </DynamicContainer>
              <div className="hai-mb-1 mk-multiselect onvif-multiselect">
                {formikProps.values.location?.map((_value: string, index: number) => {
                  return (
                    <DynamicContainer minColumns={3} key={index} className="mk-multiselect-item">
                      <div className="d-flex align-items-start" style={{ marginBottom: '11px' }}>
                        <FormikTextfield
                          className={index === 0 ? 'multiselect first' : 'multiselect'}
                          title={index === 0 ? t('settings.services.section.onvif.location') : undefined}
                          name={`location[${index}]`}
                        />
                        {formikProps.values.location.length > 1 && (
                          <IconButton
                            style={{ backgroundColor: 'transparent' }}
                            className="hai-ml-2 hai-mt-1"
                            onClick={(e: any) => handleRemoveLocation(e, index)}
                          >
                            <Icon iconname="Remove" className="gray-07-svg" />
                          </IconButton>
                        )}
                      </div>
                    </DynamicContainer>
                  );
                })}
              </div>
              <Button variant="secondary" onClick={handleAddLocation}>
                {t('general.add')}
              </Button>
              <div className="hai-mt-6 hai-mb-6 haiui-body-02 hai-gray-08">
                {t('settings.services.section.onvif.reboot')}
              </div>
            </FormSection>
          </form>
        );
      }}
    </Formik>
  );
};
